<template>
  <div class="track" :id="'track'+track.tour_index" v-bind:class="{ expanded: track.expanded }">
    <div class="track-heading">
      <h2 class="artist" v-on:click="toggle">
        <span class="track-number">{{track.tour_index}}</span>
        <span class="track-name">{{track.artist}}</span>
      </h2>
      <h3 class="art">{{track.title}}</h3>
      <h3 class="info">
        <span class="track-length">{{track.length}}</span>
        <span class="track-location">{{track.location}}</span>
      </h3>
      <button v-on:click="toggle" class="close">×</button>
    </div>
    <track-list-detail
      v-bind:track="track">
    </track-list-detail>
  </div>
</template>

<script>
import Vue from 'vue'

import TrackListDetail from '@/components/ListenPage/TrackListDetail'
import Velocity from 'velocity-animate'

export default {
  name: 'track-list-item',
  props: ['track', 'soundcloud'],
  components: { TrackListDetail },
  methods: {
    toggle: function () {
      if (!this.track.expanded && !this.track.playing) {
        // @TODO Velocity isn't work
        Velocity(
          this.$el,
          'scroll',
          {
            container: document.getElementById('track-list'),
            duration: 1000,
            offset: 102
          }
        )
        this.soundcloud.api.setVolume(0)
        this.soundcloud.api.skip(this.track.track_number)
        // I'm lowering and then raising volume
        // to avoid a blip of sound that sometimes
        // occurs when re-pausing a track that is
        // already paused
        this.soundcloud.api.setVolume(100)
        this.soundcloud.api.seekTo(0)
      } else {
        this.soundcloud.api.pause()
      }

      Vue.set(this.track, 'expanded', !this.track.expanded)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ListenPage/TrackListItem.vue?628b6380